<template lang="pug">
  y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" max-width="600px")
    v-card
      v-card-title.pa-0
        v-row.px-5.pt-3.pb-2(v-if="editedWeight.length > 0" no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].success600}`")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].basic100" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic100--text {{ $t('save_changes') }}
          v-col.ml-3.shrink
            v-layout
              v-btn.mr-2.my-auto(depressed small outlined color="basic100" @click="clearTask()")
                .button-AA-small.basic100--text {{ $t('cancel') }}
              v-btn.my-auto.basic100(depressed small :loading="isSaving" @click="saveTask()" :disabled="disableSaveWeight")
                div.button-AA-small(:class="disableSaveWeight ? 'basic600--text' : 'success600--text'") Save
        v-row.px-5.pt-3.pb-2(v-else no-gutters align="center")
          v-col.shrink
            v-btn.ml-n3(text icon @click="showModal = !showModal" height)
              eva-icon(name="arrow-back-outline" :fill="$vuetify.theme.themes[$theme].primary" width="24" height="24")
          v-col.ml-3
            p.mb-0.h6.basic800--text {{ $t('set_product_weight') }}

      v-card-text.pa-0

        //- TOP INPUT
        v-text-field.mx-4.my-2(v-model="searchText" placeholder='Search product' hide-details dense outlined height="40" background-color="basic200")
        v-divider.basic200
        v-form(ref="form")
          v-layout.pa-4.mb-n3
            v-text-field(v-model='weight' placeholder="Min = 0.1 kg | Max = 60 kg" hide-details="auto" dense outlined height="40" background-color="basic200" type="number" min="0.1" max="60" step="0.1" persistent-hint :rules="weight ? rules.weight : []")
            v-btn.ml-2(color='textColorAccent' outlined height=40 :loading="isLoading" @click="startBulkUpdate" :disabled="weight == null || !weight" style="background-color:var(--v-infoT08)")
              .button-AA-medium(:class="!weight ? 'basic500--text' : 'info500--text'")| {{ $t('apply') }}
          v-layout.px-4.mb-n3
            eva-icon.mt-1.mr-1(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" width="16" )
            .align-self-center.c1.basic600--text| {{ $t('apply_text') }}
        
        //- PRODUCT LIST
        v-layout.my-6(v-if="isFetching")
          v-row.fill-height.ma-0(align='center' justify='center')
            v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
        .contain-layout(v-else)
          v-layout.my-6(v-if="products.length == 0")
            v-row.fill-height.ma-0(align='center' justify='center')
              div.mx-auto
                v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
                p.caption {{ $t('products_not_found') }}
          .items-layout(v-else)
            .list-item.my-2(three-line)
              template(v-for='product in curretProducts')
                edit-product-item-weight(:product="product" :key="product.id" @editWeight="updateTask($event)" :focused="editedWeight.some(x => x.id==product.id)" :edited="editedWeight[editedWeight.findIndex(x => x.id==product.id)]")
        y-pagination.mx-3.mt-4.mb-6(v-model="page" :pageSize="fetchCount" :count="totalCount")

</template>

<script>
import { mapActions } from 'vuex'
import EditProductItemWeight from '@/components/EditProductItemWeight.vue'

export default {
  name: 'SetProductWeight',
  components: { EditProductItemWeight },
  props: ['open', 'company'],
  data: () => ({
    isFetching: false,
    isSaving: false,
    isTyping: false,
    fetchCount: 10,
    page: 1,
    totalCount: 0,
    products: [],
    searchText: '',
    weight: null,
    isLoading: false,
    searchCountDown: null,
    rules: {
      weight: [
        v => v >= 0.1 || 'Weight should not be below 0.1 KG',
        v => v <= 60 || 'Weight should not be above 60 KG',
      ]
    },
    editedWeight: [],
  }),
  computed: {
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    curretProducts () {
      return this.products
    },
    disableSaveWeight () {
      if (this.editedWeight.filter(f => f.weight < 0.1 || f.weight > 60).length > 0) {
        return true
      }
      return false
    }
  },
  watch: {
    page (val) {
      if (!this.isFetching) {
        this.fetchProducts(val)
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem()
      }, 500)
    }
  },
  mounted () {
    this.fetchProducts(1)
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchProducts(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/products/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-weight`
      if (this.searchText) {
        url += `&search=${this.searchText}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.products = response.data.results
        this.totalCount = response.data.count
      }).catch(() => {})
    },
    clickAddProduct () {
      this.showAddProductDialog = true
    },
    searchItem () {
      let searchUrl = `/products/?page=1&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      this.isFetching = true
      this.page = 1
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.products = response.data.results
          this.totalCount = response.data.count
        }).catch(() => {})
    },
    async startBulkUpdate () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      for (var i = this.products.length; i--;) {
        let product = this.products[i]
        await this.axios.patch(`/products/${product.id}/`, { weight: this.weight })
        .then(response => {
          this.products[i] = response.data
          if (i === 0) {
            this.isLoading = false
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
          this.isLoading = false
          return
        })
      }
    },
    updateTask(product){
      var index = this.editedWeight.findIndex(x => x.id==product.id); 
      if (index === -1) {
        this.editedWeight.push(product)
      } else if (product.weight !== null){
        this.editedWeight[index].weight = product.weight
      } else {
        this.editedWeight.splice(index, 1);
      }
    },
    async saveTask () {
      this.isSaving = true
      for (const product of this.editedWeight) {
        await this.axios.patch(`/products/${product.id}/`, { weight: product.weight }).catch(() => {})
        // await this.axios.patch(`/products/${product.id}/`, { inventory_qty: product.quantity }).catch(() => {})
      }
      this.isSaving = false
      this.clearTask()
    },
    clearTask() {
      this.editedWeight = []
      this.products = []
      this.fetchProducts(1)
    },
  }
}
</script>

<style scoped>
.count-list-layout {
  position: absolute;
  right: 4px;
}
.product-list-title {
  color:#2E2E2E;
  size: 9px;
  font-weight: bold;
}
.product-list-description {
  color: #2E2E2E;
  font-size: 12px;
  white-space: pre-wrap;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "apply_text": "Weight will be applied to all products in this page"
  },
  "id": {
     "apply_text": "Bobot ini akan diterapkan ke semua produk di halaman ini"
  }
}
</i18n>